/* ============================= */
/* VERSION V1.1 - SECTION CONTACT */
/* ============================= */

import React, { useState } from "react";
import "../styles/Contact.css";
import bgContact from "../assets/background/taxi-belfort-toyota-1920.webp";

const Contact = () => {
  const [status, setStatus] = useState("idle"); // idle | sending | ok | err

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === "sending") return;

    const form = e.currentTarget;
    const formData = new FormData(form);

    // Honeypot anti-spam
    const honey = (formData.get("_honey") || "").toString().trim();
    if (honey) return;

    setStatus("sending");

    try {
      const res = await fetch(
        "https://formsubmit.co/ajax/de73a42aee27cb93f7719de816c4ed29",
        {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        }
      );

      if (!res.ok) throw new Error("FormSubmit failed");

      setStatus("ok");
      form.reset();
    } catch (err) {
      console.error("Contact form error:", err);
      setStatus("err");
    }
  };

  return (
    <section
      id="contact"
      className="contact-section"
      style={{ backgroundImage: `url(${bgContact})` }}
      aria-labelledby="contact-title"
    >
      <div className="contact-container">
        <header className="contact-header">
          <h2 className="contact-title" id="contact-title">Contact</h2>
          <p className="contact-subtitle">
            Réservation, devis, aéroport… Réponse rapide.
          </p>

          {/* SEO discret */}
          <span className="sr-only">
            Contact taxi Belfort : demande de réservation, devis, gare de Belfort, aéroport Bâle-Mulhouse.
          </span>
        </header>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="hidden"
            name="_subject"
            value="Nouveau message - Taxi de la Douce"
          />
          <input type="hidden" name="_captcha" value="false" />

          <input
            type="text"
            name="_honey"
            className="honeypot"
            tabIndex="-1"
            autoComplete="off"
            aria-hidden="true"
          />

          <div className="contact-grid">
            <div className="field">
              <label htmlFor="nom">Nom</label>
              <input
                id="nom"
                type="text"
                name="nom"
                placeholder="Votre nom"
                autoComplete="name"
                required
              />
            </div>

            <div className="field">
              <label htmlFor="telephone">Téléphone</label>
              <input
                id="telephone"
                type="tel"
                name="telephone"
                placeholder="Ex : 07 49 42 49 19"
                inputMode="tel"
                autoComplete="tel"
                required
              />
            </div>

            <div className="field">
              <label htmlFor="email">Email (optionnel)</label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="Votre email"
                autoComplete="email"
              />
            </div>

            <div className="field">
              <label htmlFor="trajet">Trajet (optionnel)</label>
              <input
                id="trajet"
                type="text"
                name="trajet"
                placeholder="Ex : Belfort → Aéroport Bâle-Mulhouse"
              />
            </div>
          </div>

          <div className="field">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Date/heure, adresse de départ, destination, passagers, bagages..."
              required
            />
          </div>

          <button className="contact-btn" type="submit" disabled={status === "sending"}>
            {status === "sending" ? "Envoi..." : "Envoyer la demande"}
          </button>

          <div aria-live="polite">
            {status === "ok" && (
              <p className="contact-feedback success">
                ✅ Message envoyé. Merci ! Je vous réponds rapidement.
              </p>
            )}

            {status === "err" && (
              <p className="contact-feedback error">
                ❌ L’envoi a échoué. Réessayez ou contactez-moi sur WhatsApp.
              </p>
            )}
          </div>

          <div className="contact-actions">
            <a
              href="https://wa.me/33749424919"
              className="whatsapp-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              💬 WhatsApp
            </a>
            <a className="phone-link" href="tel:+33749424919">
              📞 Appeler
            </a>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;


